import { ModelBase } from '../../core/model/model-base';
import { ErrandType } from '../../round-planning/model/const/enums';

export class ErrandTag extends ModelBase {
  constructor(data?: Partial<ErrandTag>) {
    super();
    Object.assign(this, data ?? {});
    this.userGroupIds = [...(data?.userGroupIds ?? [])];
    this.userGroupNames = [...new Set((data?.userGroupNames ?? []).filter(name => !!name?.trim()))].sort((left, right) =>
      left.localeCompare(right)
    );
  }

  name = '';
  isEnabled = true;
  userGroupCount = 0;
  userGroupNames: string[] = [];
  canDelete = true;
  isConfidential = false;
  userGroupIds: string[] = [];

  get userGroupNamesForUI(): string {
    return this.userGroupNames.join(', ');
  }

  toSavePayload(): ErrandTagSavePayload {
    return {
      id: this.id,
      name: this.name?.trim(),
      isEnabled: this.isEnabled,
      userGroupIds: [...this.userGroupIds],
    };
  }

  override toString(): string {
    return this.name;
  }
}

export interface ErrandTagSavePayload {
  id?: string;
  name: string;
  isEnabled: boolean;
  userGroupIds: string[];
}

export interface ErrandTagSelection {
  id: string;
  name: string;
  isEnabled: boolean;
}

export interface ErrandTagUserGroupSelection {
  id: string;
  name: string;
  isSystemOwners?: boolean;
  users?: ErrandTagUserSelection[];
}

export interface ErrandTagUserSelection {
  id: string;
  name: string;
}

export interface ErrandTagAffectedUser {
  id: string;
  name: string;
  userGroupNames: string[];
  userGroupNamesForUI: string;
}

export interface ErrandAssignmentOption {
  id: string;
  name: string;
  executorGroupIds?: string[];
}

export interface PropertyErrandSubCategoryResponsibility {
  id?: string;
  errandSubCategoryId: string;
  errandCategoryName?: string;
  errandSubCategoryName?: string;
  resourceId?: string;
  resourceName?: string;
  executorGroupId?: string;
  executorGroupName?: string;
  executorWebUserId?: string;
  executorWebUserName?: string;
}

export interface ErrandAssignmentOptions {
  errandType: ErrandType;
  propertyId: string;
  errandTagId?: string;
  errandSubCategoryId?: string;
  resources: ErrandAssignmentOption[];
  executorGroups: ErrandAssignmentOption[];
  executorWebUsers: ErrandAssignmentOption[];
  executorWebUserPool?: ErrandAssignmentOption[];
  configuredResponsibility?: PropertyErrandSubCategoryResponsibility;
}
